<!-- Spinner shown during API loading -->
<div *ngIf="loading" class="spinner-container">
    <mat-spinner></mat-spinner>
</div>

<!-- Reports list shown once data is loaded -->
<div *ngIf="!loading" class="reports-container">
    <div class="card" *ngFor="let report of reports" (click)="onCardClick(report)">

        <!-- Left Side: Report Details -->
        <div class="card-left">
            <div class="report-name">{{ report.reportName }}</div>
            <div class="report-type">{{ report.reportType }}</div>
            <div class="report-patents">
                Patents: {{ report.patentNumbers.length }}
                <span class="tooltip">
            <ng-container *ngFor="let patent of report.patentNumbers">
              {{ patent }}<br>
            </ng-container>
          </span>
            </div>
        </div>

        <!-- Right Side: Date Information -->
        <div class="card-right">
            <div class="report-date" [title]="getExactDate(report.createdAt)">
                {{ getRelativeDate(report.createdAt) }}
            </div>
        </div>
    </div>
</div>